import React from "react";

import { StrainListHeaders } from "@/custom-types/Directus";

import ExpandableContainer from "@/components/botanic/ExpandableContainer";
import DirectusHtmlWrapper from "@/components/DirectusHtmlWrapper";

type Props = {
  hero: StrainListHeaders<string> | null;
  displayTitle: string;
};

const StrainListHeader: React.FunctionComponent<Props> = ({
  hero,
  displayTitle,
}: Props) => {
  const { description } = hero || {};

  return (
    <div className="container mt-xxl">
      <div className="bg-white rounded">
        <h1 className="heading--m mb-lg">{displayTitle}</h1>
        {description && (
          <ExpandableContainer className="mb-xl" initialHeight="102px">
            <DirectusHtmlWrapper
              data-testid="hero-description"
              content={description}
            />
          </ExpandableContainer>
        )}
      </div>
    </div>
  );
};

export default StrainListHeader;
